module.exports = __webpack_public_path__ + "img/Toys & Games.a1bbe4f6.png";